export default __webpack_public_path__ + "static/DINBold-c6271201cf05e5545176d374408a1cb8.woff";